import React from "react";
import Modal from "src/components/common/Modal";
import Button from "src/components/app/Button";
import { CheckCircle } from "lucide-react";

interface DiscountSuccessModalProps {
  show: boolean;
  onClose: () => void;
  discountName: string;
  discountAmount: number;
}

const DiscountSuccessModal: React.FC<DiscountSuccessModalProps> = ({
  show,
  onClose,
  discountName,
  discountAmount,
}) => {
  return (
    <Modal show={show} handleClose={onClose} showCloseButton={false}>
      <div className="bg-white rounded-xl p-6 max-w-sm mx-auto">
        <div className="text-center">
          {/* Success Icon */}
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
          </div>

          {/* Success Message */}
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Discount Applied Successfully!
          </h3>

          <p className="text-sm text-gray-600 mb-4">
            You have successfully applied the discount
          </p>

          {/* Discount Details */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex justify-between items-center">
              <span className="text-sm font-medium text-gray-700">
                {discountName}
              </span>
              <span className="text-sm font-semibold text-green-600">
                -₹{discountAmount}
              </span>
            </div>
          </div>

          {/* Action Button */}
          <Button
            size="lg"
            fullWidth
            onClick={onClose}
            variant="contained"
            rounded="md"
          >
            Got it, thanks!
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DiscountSuccessModal;
